import { Injectable } from "@angular/core";

@Injectable({
    providedIn: 'root'
})

export class ImageService {
    constructor() { }



    /**
     * Load image
     * @param file 
     * @returns Promise
     */
    loadImage(file: File): Promise<string> {
        return new Promise((resolve, reject) => {
            if (!file || !file.type.startsWith('image/')) {
                reject('File is not an image');
                return;
            }
            const reader = new FileReader();
            reader.onload = () => {
                resolve(reader.result as string);
            };
            reader.onerror = () => {
                reject('Error loading image');
            };
            reader.readAsDataURL(file);
        });
    }
}